import {
  INTERCEPTOR_TRIGGER_IDS,
  interceptorEvents,
  interceptorStorage,
} from "./interceptorTriggers";

// «Долгое бездействие» на телефоне: столько без касаний и прокрутки.
const MOBILE_IDLE_MS = 60 * 1000;

// Окно уже показано в этой загрузке страницы — на случай, если хранилище
// недоступно (заблокированы данные сайта) и отметка в нём не сохраняется.
let firedInPage = false;

export const initInterceptor = ({ onTrigger }) => {
  if (typeof window === "undefined") {
    return {
      handleRouteChange: () => {},
      destroy: () => {},
    };
  }

  let timeTriggerTimeout;
  let idleTimeout;
  let currentPath = "";
  const isTouchDevice = window.matchMedia?.("(pointer: coarse)").matches;

  const triggerPopup = (triggerId) => {
    // const triggerConfig = INTERCEPTOR_TRIGGERS[triggerId];
    if (window.location?.pathname?.includes("personal")) {
      return;
    }
    if (firedInPage || interceptorStorage.hasAnyTriggerFired()) {
      return;
    }
    const opened = onTrigger?.({
      triggerId,
      // title: triggerConfig?.title,
      // subtitle: triggerConfig?.subtitle,
      // interceptorData: interceptorPayload.toString(triggerId),
    });
    if (opened) {
      firedInPage = true;
      interceptorStorage.markTriggerFired(triggerId, {
        path: currentPath,
      });
    }
  };

  // Переход записываем и после показа окна: он продлевает визит.
  const handleRouteChange = (url) => {
    currentPath = url;
    interceptorStorage.recordPageView(url);
  };

  const initTimeTrigger = () => {
    if (interceptorStorage.hasAnyTriggerFired()) {
      return;
    }
    const state = interceptorStorage.read();
    if (interceptorEvents.shouldTriggerTimeOnSite(state)) {
      triggerPopup(INTERCEPTOR_TRIGGER_IDS.timeOnSite3min);
      return;
    }
    const delay = interceptorEvents.getTimeOnSiteDelayMs(state);
    if (delay !== null) {
      timeTriggerTimeout = window.setTimeout(() => {
        triggerPopup(INTERCEPTOR_TRIGGER_IDS.timeOnSite3min);
      }, delay);
    }
  };

  const handleExitIntent = (event) => {
    if (interceptorStorage.hasAnyTriggerFired()) {
      return;
    }
    if (!interceptorEvents.isExitIntent(event)) {
      return;
    }
    // В каталоге моделей — своё окно «Уже уходите?», на остальных страницах —
    // «Нужна помощь с выбором?».
    triggerPopup(
      interceptorEvents.isModelCatalogPage(currentPath)
        ? INTERCEPTOR_TRIGGER_IDS.exitModelCatalog
        : INTERCEPTOR_TRIGGER_IDS.pageDepth4,
    );
  };

  // На телефоне курсора нет, вместо ухода курсора — долгое бездействие.
  const resetIdleTimer = () => {
    window.clearTimeout(idleTimeout);
    idleTimeout = window.setTimeout(() => {
      triggerPopup(INTERCEPTOR_TRIGGER_IDS.pageDepth4);
    }, MOBILE_IDLE_MS);
  };

  const destroy = () => {
    if (timeTriggerTimeout) {
      window.clearTimeout(timeTriggerTimeout);
    }
    document.removeEventListener("mouseout", handleExitIntent);
    window.clearTimeout(idleTimeout);
    window.removeEventListener("touchstart", resetIdleTimer);
    window.removeEventListener("scroll", resetIdleTimer);
  };

  initTimeTrigger();
  document.addEventListener("mouseout", handleExitIntent);
  if (isTouchDevice) {
    resetIdleTimer();
    window.addEventListener("touchstart", resetIdleTimer, { passive: true });
    window.addEventListener("scroll", resetIdleTimer, { passive: true });
  }

  return {
    handleRouteChange,
    destroy,
  };
};
